module.exports = "/assets/dist/images/Mircosoft.png?6319df9fc612496ed390b8b5c3dd22b3";